import React from 'react'
import { Box, Typography } from '@mui/material'
import AdxPdfImageViewer from 'components/reusable/AdxPdfImageViewer'
import AdxButton from 'components/custom/AdxButton'

const RequestAttachment = ({ item }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="body1" color="light-gray-text.main" fontWeight={700}>
        Attachment(s)
      </Typography>
      <Box
        sx={{
          width: '100%',
          boxSizing: 'border-box',
          backgroundColor: 'gray-background.main',
          borderRadius: '4.5px',
          display: 'flex',
          alignItems: 'center',
          p: 2,
          gap: 2,
        }}
      >
        <Box sx={{ width: '73px' }}>
          <AdxPdfImageViewer fileUrl={item.attachment_url} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 1,
          }}
        >
          <Typography variant="body1" color="dark-text.main">
            {item.attachment}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <AdxButton
              variant={'outlined'}
              size={'tiny'}
              onClick={() => window.open(item.attachment_url, '_blank')}
            >
              View
            </AdxButton>
            <AdxButton
              variant={'outlined'}
              size={'tiny'}
              href={item.attachment_url}
              target="_blank"
              download
            >
              Download
            </AdxButton>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default RequestAttachment
